import moment from "moment";
import momentTz from "moment-timezone";
import axios from "axios";
import { getEventConfig, getMenuActionsMap } from "@/services/hrdc_event/eventRegistry";

const HRDC_CLIENT_NO = "303715";
const ACCOUNT_CODE = "200L-03-01";
const TRACKING_DIVISION = "Division";
const PAYMENT_VOUCHER_SUCCESS_STATUS = "success";
const PAYMENT_VOUCHER_EXECUTING_STATUS = "executing";
const PAYMENT_VOUCHER_PENDING_STATUS = "pending";
const PAYMENT_VOUCHER_FAILED_STATUS = "failed";
const HRDC_MENU_ACTIONS = [
  { title: "Edit Details", route: "EditHrdcApplication" },
  { title: "General Info", route: "AddGeneralInfo" },
  { title: "Send HRDC Email to Client", route: "SendHrdcEmailToClient" },
  { title: "Grant Approval & Revert Form", route: "ClientRevertForm" },
  { title: "Manual Invoice to HRDC", route: "ManualInvoiceToHrdc" },
  { title: "Claim Submitted to HRDC", route: "ClaimSubmitToHrdc" },
  { title: "Claim Approved from HRDC", route: "ClaimApprovedFromHrdc" },
  { title: "Payment Received from HRDC", route: "PaymentReceivedFromHrdc" },
];

function getMenuActions(serviceKey) {
  if (serviceKey === "hrdc") return HRDC_MENU_ACTIONS;
  const map = getMenuActionsMap();
  return map[serviceKey] || [];
}

export default {
  data: () => ({
    HRDC_CLIENT_NO,
    name1: null,
    confirmationLetterName: null,
    jd14Name: null,
    t3Name: null,
    agendaAtchName: null,
    guidelineName: null,
    flyerName: null,
    attendanceFormName: null,
    hrdcType: null,
    xeroRedirectUri: null,
    languages: [
      {
        isoLanguageName: "English",
        isoLanguageCode: "en",
      },
      {
        isoLanguageName: "Chinese",
        isoLanguageCode: "zh",
      },
    ],
    PAYMENT_VOUCHER_SUCCESS_STATUS,
    PAYMENT_VOUCHER_EXECUTING_STATUS,
    PAYMENT_VOUCHER_PENDING_STATUS,
    PAYMENT_VOUCHER_FAILED_STATUS,
    staticTaxpodPricing: [2888, 2388, 1998, 1798, 1498],
    staticTaxpodData: [
      {
        price: 1498,
        flyer: "2.0",
        trainingDays: 4,
        viewingHours: 28,
      },
      {
        price: 1798,
        flyer: "2.0",
        trainingDays: 4,
        viewingHours: 28,
      },
      {
        price: 1998,
        flyer: "",
        trainingDays: 3,
        viewingHours: 21,
      },
      {
        price: 2388,
        flyer: "",
        trainingDays: 3,
        viewingHours: 21,
      },
      {
        price: 2888,
        flyer: "2.0",
        trainingDays: 4,
        viewingHours: 28,
      },
    ],
    paymentAdviceOpts: [
      "Stripe",
      "iPay88",
      "Bank Transfer",
      "Cheque",
      "Credit Card Machine",
      "ATM Cash Deposit",
    ],
    grantRevertOpts: [
      { text: "Grant Approved", value: 1 },
      { text: "Grant Issue", value: 0 },
    ],
    formRevertOpts: [
      { text: "Forms Completed", value: 1 },
      { text: "Forms Issue", value: 0 },
    ],
    yycMobileHotline: "+60193686868",
    learnTaxPodEmail: process.env.VUE_APP_LEARN_EMAIL,
    isSalesperson: ["taxpod-salesperson"],
    isSalesManager: ["taxpod-sales-manager"],
    isHrdcAdmin: ["hrdc-admin"],
    isHrdcSuperAdmin: ["hrdc-super-admin"],
    isTaxpodAdmin: ["taxpod-admin"],
    isTaxpodApproval1Admin: ["hrdc-taxpod-approval-1-admin"],
    isTaxpodApproval2Admin: ["hrdc-taxpod-approval-2-admin"],
    isFinanceArAdmin: ["finance-ar-admin"],
    isFinanceApAdmin: ["finance-ap-admin"],
    isCustomerServiceAdmin: ["taxpod-customer-service"],
    isDmAdmin: ["hrdc-dm-admin"],
    isHrdcAdminRoles: false,
    isHrdcSuperAdminRoles: false,
    isTaxpodAdminRoles: false,
    isTaxpodApproval1AdminRoles: false,
    isTaxpodApproval2AdminRoles: false,
    isFinanceArAdminRoles: false,
    isFinanceApAdminRoles: false,
    isSalespersonRoles: false,
    isSalesManagerRoles: false,
    isCustomerServiceAdminRoles: false,
    isDmAdminRoles: false,
    HRDC_BLUE_THEME_COLOR: "#063058",
    INVOICE_TYPE: "ACCREC",
    VUE_APP_API_AUTHORIZATION_VISION: "123abc",
    INDEX_MENU_ACTIONS: [],
    paymentMethodItems: [
      "Bank Transfer",
      "Credit Card/FPX/Grab Pay/Apple Pay/Google Pay",
      "Credit Card Instalment Plan",
      "Cheque",
      "iPay88",
      "Other",
    ],
    staticPricing: [],
    EVENT_TYPE: {},
    EVENT_BULK_NEW_APPLICATION_TEMPLATE_NAME: "Bulk Application Template.xlsx",
    EVENT_BULK_NEW_APPLICATION_DUMMY_TEMPLATE_NAME:
      "Bulk Application Template (Dummy).xlsx",
    EVENT_BULK_NEW_APPLICATION_TEMPLATE_FILE_URL:
      "assets/storage/bulk_application_template.xlsx",
    EVENT_BULK_NEW_APPLICATION_DUMMY_TEMPLATE_FILE_URL:
      "assets/storage/dummy_bulk_application_template.xlsx",
    EVENT_BULK_CASE_ASSIGNATION_PIC_EMAIL: "kokxiang.lim@yycadvisors.com",
    EVENT_BULK_CASE_ASSIGNATION_PIC_NAME: "Kenneth Lim Kok Xiang",
    speakers: [
      "Zen Chow",
      "Tifannyz",
      "Fong Ying",
      "Jeremy Tan Lai Fu",
      "Shin",
    ],
    staticTaxpodDocs: ["guideline", "flyer"],
    staticEventDocs: ["guideline", "agenda"],
    // Total Key Stages for taxPOD.
    taxPODPayAndRefundKeyStages: 14,
    taxPODClaimBasisKeyStages: 8,
    // Total Key Stages for Event.
    eventPayAndRefundKeyStages: 14,
    eventClaimBasisKeyStages: 7,
    SURVEY_RESTRICT_FIELD: ["textarea"],
    REFUND_TAXPOD_ATTACHMENTS: [
      "paymentAdviceFromHrdc",
      "creditNote",
      "autoGeneratedTaxpodInvoice",
      "paymentAdviceFromClient",
    ],
    TAXPOD_INVOICE_REFERENCE: `PEMBANGUNAN SUMBER MANUSIA BERHAD`,
    generateCnOption: [
      {
        text: "Normal CN",
        value: "NORMAL_CN",
      },
      {
        text: "Special CN",
        value: "SPECIAL_CN",
      },
    ],
  }),
  methods: {
    localeDate() {
      return momentTz().tz(process.env.VUE_APP_TZ);
    },
    // Check if form already filled.
    checkFormAlreadyFilledGte(currentStageId, maxStageId, errorMsg) {
      this.checkFormAlreadyFilled(currentStageId, maxStageId, true, errorMsg);
    },
    checkFormAlreadyFilledGreater(currentStageId, maxStageId, errorMsg) {
      this.checkFormAlreadyFilled(currentStageId, maxStageId, false, errorMsg);
    },
    checkFormAlreadyFilled(
      currentStageId,
      maxStageId,
      inclusive,
      errorMessage = null
    ) {
      if (
        (inclusive && currentStageId >= maxStageId) ||
        (!inclusive && currentStageId > maxStageId)
      ) {
        let errorMsg = "Please be informed that this form already filled in!";
        if (errorMessage) {
          errorMsg = errorMessage;
        }
        this.alertError.push(errorMsg);
        this.editMode = true;
      }
    },
    checkFormNotYetFilledLesser(
      currentStageId,
      maxStageId,
      errorMessage = null
    ) {
      if (currentStageId < maxStageId) {
        let errorMsg = "Please complete previous step";
        if (errorMessage) {
          errorMsg = errorMessage;
        }
        this.alertError.push(errorMsg);
        this.btnDisabled = true;
      }
    },
    roleMiddleware(roles, serviceKey) {
      let route = null;
      const eventConfig = getEventConfig(serviceKey);
      if (eventConfig) {
        route = `${eventConfig.routePrefix}Application`;
      }

      if (
        roles.length == 0 ||
        (roles.length == 1 &&
          roles.find((item) => item.slug == "taxpod-salesperson"))
      ) {
        this.$router.push({
          name: route,
          query: {
            viewId: "all",
          },
          params: {
            modelKey: serviceKey,
          },
        });

        return false;
      }
    },
    serviceDataAssignation(serviceKey) {
      switch (serviceKey) {
        case "hrdc":
          this.name1 = "taxPOD";
          this.hrdcType = 0;
          this.xeroRedirectUri = `${process.env.VUE_APP_URL}/en/service/${serviceKey}/callback`;
          this.INDEX_MENU_ACTIONS = getMenuActions(serviceKey);
          this.guidelineName = `Grant Application Guide - YYC TaxPOD - `;
          this.flyerName = `Flyer-`;
          break;
        default: {
          // Event modules - config-driven
          const config = getEventConfig(serviceKey);
          if (config) {
            this.name1 = config.name1;
            this.confirmationLetterName = config.confirmationLetterTemplate;
            this.jd14Name = config.jd14Template;
            this.t3Name = config.t3Template;
            this.agendaAtchName = config.agendaAttachmentName;
            this.guidelineName = config.guidelineName;
            this.hrdcType = config.hrdcType;
            this.xeroRedirectUri = `${process.env.VUE_APP_URL}/en/service/${serviceKey}/${config.xeroCallbackSuffix}`;
            this.INDEX_MENU_ACTIONS = getMenuActions(serviceKey);
            this.staticPricing = config.staticPricing;
            if (config.attendanceFormName) this.attendanceFormName = config.attendanceFormName;
          }
          break;
        }
      }
    },
    getOriginalAttachmentFileExtension(fileObj) {
      return new Promise((resolve) => {
        var fileReader = new FileReader();
        fileReader.readAsArrayBuffer(fileObj);
        fileReader.onloadend = function (e) {
          var arr = new Uint8Array(e.target.result).subarray(0, 4);
          var header = "";
          for (var i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
          }

          let fileOriginalExtension = null;

          // Check the file signature against known types
          switch (header) {
            case "25504446":
              fileOriginalExtension = "application/pdf";
              break;
            case "89504e47":
              fileOriginalExtension = "image/png";
              break;
            case "ffd8ffe0":
            case "ffd8ffe1":
            case "ffd8ffe2":
            case "ffd8ffe3":
            case "ffd8ffe8":
              fileOriginalExtension = "image/jpeg";
              break;
            default:
              fileOriginalExtension = fileObj.type;
              break;
          }

          resolve(fileOriginalExtension);
        };
      });
    },
    getEnv() {
      let env = "local";
      switch (process.env.VUE_APP_ENV) {
        case "local":
          env = "local";
          break;
        case "dev":
          env = "dev";
          break;
        case "production":
          env = "production";
          break;
      }

      return env;
    },
    getInvoiceStatus() {
      let invoiceStatus = "DRAFT";
      const env = this.getEnv();
      if (env == "production") {
        invoiceStatus = "AUTHORISED";
      }

      return invoiceStatus;
    },
    getService(serviceKey) {
      if (serviceKey === "hrdc") {
        return { url: process.env.VUE_APP_SERVICE_URL_HRDC };
      }
      const config = getEventConfig(serviceKey);
      if (config) {
        return { url: config.serviceUrl };
      }
      return null;
    },
    requestAuthorizeApp(xeroParams = null) {
      const responseType = "code";
      const clientId = process.env.VUE_APP_XERO_CLIENT_ID;
      const scope =
        "openid offline_access accounting.transactions accounting.contacts accounting.settings accounting.attachments accounting.attachments.read";
      let redirectUri = `${process.env.VUE_APP_URL}/en/service/hrdc/callback`;
      let state = this.$route.query._ausk;

      if (xeroParams) {
        redirectUri = xeroParams.redirectCallbackUri;
        state = xeroParams.stateType;
      }

      const getAccessTokenUrl = `
        ${process.env.VUE_APP_XERO_LOGIN_URL}?response_type=${responseType}&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}
      `;

      return getAccessTokenUrl;
    },
    // Request access token by refresh token. Xero client credentials + token
    // URL are applied server-side; the client only sends the refresh token.
    async xeroRequestAccessToken(url, bearerToken, refreshToken) {
      return await axios
        .post(
          url,
          {
            grant_type: "refresh_token",
            refresh_token: refreshToken,
          },
          {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        )
        .then((response) => {
          if (
            !response ||
            response.status !== 200 ||
            !response.data.data.access_token
          ) {
            throw new Error(
              "Unable to generate access token via refresh token"
            );
          }

          return response.data;
        })
        .catch((err) => {
          // console.log(err)
          return err.message;
        });
    },
    async xeroRequestTenantId({ url, headers, postData }) {
      return await axios
        .post(
          url,
          { ...postData },
          {
            headers,
          }
        )
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          console.log(err);
          return err.message;
        });
    },
    async xeroCallApi(item) {
      let trackingCategories = null;
      let divisonTracking = null;
      let divisonTrackingCategory = null;
      let divisonTrackingOption = null;
      // let productTracking = null;
      // let productTrackingCategory = null;
      // let productTrackingOption = null;
      const { authorization, ...data } = item;
      const domainUrl = this.getService(data.service_key).url;
      const url = `${domainUrl}/v1/en/console/xero/xero-api`;

      return await axios
        .post(url, data, {
          headers: {
            Authorization: `Bearer ${authorization}`,
          },
          ...(data.config && Object.keys(data.config).length > 0
            ? data.config
            : {}),
        })
        .then((response) => {
          switch (data.api_type) {
            case "get_contacts":
              return response.data.Contacts.find((item) => {
                return item.AccountNumber == HRDC_CLIENT_NO;
              });

            case "get_accounts":
              return response.data.Accounts.find((item) => {
                return item.Code == ACCOUNT_CODE;
              });

            case "get_tracking_categories":
              trackingCategories = response.data.TrackingCategories;

              divisonTrackingCategory = trackingCategories.find(
                (category) => category.Name === TRACKING_DIVISION
              );

              // Division - taxPOD/taxPOD - Event
              divisonTrackingOption = divisonTrackingCategory.Options.find(
                (option) => option.Name === data.tracking_category_name
              );

              divisonTracking = {
                Name: divisonTrackingCategory.Name,
                TrackingCategoryID: divisonTrackingCategory.TrackingCategoryID,
                Option: divisonTrackingOption.Name,
              };

              return {
                divisonTracking,
              };

            default:
              return response;
          }
        });
    },
    calculateLineAmounts(amount, taxRate) {
      const unitAmount = amount / (taxRate / 100 + 1);
      const taxAmount = amount - unitAmount;
      return { unitAmount, taxAmount };
    },
    convertDateFormat(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD HH:mm:ssZ").format("D MMMM YYYY");
      }

      return "-";
    },
    generateHrdcInvoiceDesc({
      programmeName,
      trainingDate,
      companyName,
      grantApprovalNo,
      note,
    }) {
      let description = `${programmeName}\nEvent Name: ${programmeName}\nDate (Day): ${trainingDate}\nCompany Name: ${companyName.toUpperCase()}\nGrant No: ${grantApprovalNo}`;
      if (note) {
        description = description + `\n\nNote: ${note}`;
      }

      return description;
    },
    getLanguageByIsoCode(isoCode) {
      if (!isoCode) {
        return "English";
      }

      return this.languages.find((lang) => lang.isoLanguageCode == isoCode)
        .isoLanguageName;
    },
    configMenu(data) {
      const disabledRolesForHrdc = "taxpod-salesperson";
      const rolesArray = data.roles.map((item) => item.slug);

      for (const menu of data.menu) {
        // Start with default permission
        menu.isAllowed = true;

        // Handle disabled roles logic
        const isSingleDisabledRole =
          rolesArray.length === 1 && rolesArray[0] === disabledRolesForHrdc;
        const isNoRole = rolesArray.length === 0;

        if (
          (isSingleDisabledRole || isNoRole) &&
          menu.disabledForRoles?.includes(disabledRolesForHrdc)
        ) {
          menu.isAllowed = false;
        }

        // Handle only allowed roles logic
        if (menu.onlyAllowForRoles) {
          menu.isAllowed = rolesArray.some((role) =>
            menu.onlyAllowForRoles.includes(role)
          );
        }
      }
    },
    formatEventTitle(item, hrdcType) {
      const languageName = this.getLanguageByIsoCode(item.language);

      switch (hrdcType) {
        case 2:
          return `${item.title} (${moment(item.startDate).format(
            "DD/MM/YYYY"
          )}) - ${languageName}`;
        default:
          return `${item.title} (${moment(item.startDate).format(
            "DD/MM/YYYY"
          )} - ${moment(item.endDate).format("DD/MM/YYYY")}) - ${languageName}`;
      }
    },
    showLoadingDialog() {
      this.loadingText = "Loading...";
      this.loadingDialog = true;
    },
    hideLoadingDialog() {
      this.loadingDialog = false;
    },
    getTaxpodBasePricing(price) {
      for (const pricing of this.staticTaxpodPricing) {
        if (price % pricing == 0) {
          return pricing;
        }
      }

      return false;
    },
    rolesAssignation(roles) {
      roles.forEach((item) => {
        if (this.isHrdcAdmin.includes(item.slug)) {
          this.isHrdcAdminRoles = true;
        }
        if (this.isHrdcSuperAdmin.includes(item.slug)) {
          this.isHrdcSuperAdminRoles = true;
        }
        if (this.isTaxpodAdmin.includes(item.slug)) {
          this.isTaxpodAdminRoles = true;
        }
        if (this.isTaxpodApproval1Admin.includes(item.slug)) {
          this.isTaxpodApproval1AdminRoles = true;
        }
        if (this.isTaxpodApproval2Admin.includes(item.slug)) {
          this.isTaxpodApproval2AdminRoles = true;
        }
        if (this.isFinanceArAdmin.includes(item.slug)) {
          this.isFinanceArAdminRoles = true;
        }
        if (this.isFinanceApAdmin.includes(item.slug)) {
          this.isFinanceApAdminRoles = true;
        }
        if (this.isSalesperson.includes(item.slug)) {
          this.isSalespersonRoles = true;
        }
        if (this.isSalesManager.includes(item.slug)) {
          this.isSalesManagerRoles = true;
        }
        if (this.isCustomerServiceAdmin.includes(item.slug)) {
          this.isCustomerServiceAdminRoles = true;
        }
        if (this.isDmAdmin.includes(item.slug)) {
          this.isDmAdminRoles = true;
        }
      });
    },
    capitalizeFirstLetter(string) {
      if (!string) {
        return "";
      }

      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    calculateStagePercentage(item) {
      const { isPaymentMade, keyStage } = item;

      const totalKeyStages = !this.hrdcType
        ? isPaymentMade
          ? this.taxPODPayAndRefundKeyStages
          : this.taxPODClaimBasisKeyStages
        : isPaymentMade
        ? this.eventPayAndRefundKeyStages
        : this.eventClaimBasisKeyStages;

      // Calculate the percentage
      return Math.ceil((keyStage / totalKeyStages) * 100);
    },
    clearErrorMsg(field = null) {
      if (!field) {
        for (let error in this.errorField) {
          this.errorField[error] = null;
        }
      } else {
        this.errorField[field] = null;
      }
    },
  },
};
